import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import CategoryManager from '../components/CategoryManager';
import { useTranslation } from 'react-i18next';

// SVG Icons
const TransactionIcon = () => (
    <svg className="w-6 h-6 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
);

const AddIcon = () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
    </svg>
);

const CloseIcon = () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
    </svg>
);

const FilterIcon = () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.207A1 1 0 013 6.5V4z" />
    </svg>
);

const StatsIcon = () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
    </svg>
);

const CategoryIcon = () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
    </svg>
);

const LoadingSpinner = () => (
    <div className="flex justify-center items-center h-64">
        <div className="relative">
            <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-green-500"></div>
            <div className="absolute inset-0 flex items-center justify-center">
                <TransactionIcon />
            </div>
        </div>
    </div>
);

const CarTransactionsPage = () => {
    const { t } = useTranslation();
    const [transactions, setTransactions] = useState([]);
    const [categories, setCategories] = useState([]);
    const [voitures, setVoitures] = useState([]);
    const [selectedVoiture, setSelectedVoiture] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showCategory, setShowCategory] = useState(false);
    const [showStats, setShowStats] = useState(false);

    // 🔥 AJOUT: États pour la pagination
    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalPages: 1,
        totalItems: 0,
        itemsPerPage: 50
    });

    const [showAdd, setShowAdd] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [editingTransaction, setEditingTransaction] = useState(null);
    const [deleteConfirm, setDeleteConfirm] = useState(null);
    const [filters, setFilters] = useState({
        type: '',
        category_id: '',
        startDate: '',
        endDate: ''
    });

    // Fetch all voitures to select from
    const fetchVoitures = async () => {
        try {
            const res = await fetch('https://krili-loto.com/api/voitures');
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            const data = await res.json();
            setVoitures(data);
            // Auto-select first voiture if available
            if (data.length > 0 && !selectedVoiture) {
                setSelectedVoiture(data[0]);
            }
        } catch (err) {
            console.error(err);
            setError(err.message);
        }
    };

    // 🔥 MODIFICATION: Fetch transactions avec pagination
    const fetchTransactions = async (page = 1) => {
        if (!selectedVoiture) return;

        try {
            setLoading(true);
            setError(null);
            const queryParams = new URLSearchParams({
                ...filters,
                page: page,
                limit: 50
            }).toString();

            const res = await fetch(`https://krili-loto.com/api/transactionscar/car/${selectedVoiture.id}?${queryParams}`);
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            const data = await res.json();

            if (data.success) {
                setTransactions(data.data || []);
                // 🔥 Mettre à jour la pagination
                setPagination({
                    currentPage: data.page || 1,
                    totalPages: data.totalPages || 1,
                    totalItems: data.total || 0,
                    itemsPerPage: data.limit || 50
                });
            } else {
                throw new Error(data.message);
            }
        } catch (err) {
            console.error(err);
            setError(err.message);
            setTransactions([]);
        } finally {
            setLoading(false);
        }
    };

    // Fetch categories
    const fetchCategories = async () => {
        try {
            const res = await fetch('https://krili-loto.com/api/categories');
            const data = await res.json();
            setCategories(data);
        } catch (err) {
            console.error('Error fetching categories:', err);
        }
    };

    // 🔥 AJOUT: Fonction pour changer de page
    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= pagination.totalPages) {
            fetchTransactions(newPage);
        }
    };

    useEffect(() => {
        fetchVoitures();
        fetchCategories();
    }, []);

    useEffect(() => {
        fetchTransactions(1); // 🔥 Toujours commencer à la page 1 quand les filtres changent
    }, [selectedVoiture, filters]);

    const handleCreateTransaction = async (formData) => {
        try {
            const response = await fetch('https://krili-loto.com/api/transactionscar', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ ...formData, voiture_id: selectedVoiture.id })
            });

            const data = await response.json();

            if (data.success) {
                setShowAdd(false);
                fetchTransactions(pagination.currentPage); // 🔥 Recharger la page actuelle
            } else {
                setError(data.message);
            }
        } catch (err) {
            setError('Erreur lors de la création');
        }
    };

    const handleUpdateTransaction = async (formData) => {
        try {
            const response = await fetch(`https://krili-loto.com/api/transactionscar/${editingTransaction.id}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData)
            });

            const data = await response.json();

            if (data.success) {
                setShowAdd(false);
                setEditingTransaction(null);
                fetchTransactions(pagination.currentPage); // 🔥 Recharger la page actuelle
            } else {
                setError(data.message);
            }
        } catch (err) {
            setError('Erreur lors de la mise à jour');
        }
    };

    const handleDeleteTransaction = async (id) => {
        try {
            const response = await fetch(`https://krili-loto.com/api/transactionscar/${id}`, {
                method: 'DELETE'
            });

            const data = await response.json();

            if (data.success) {
                fetchTransactions(pagination.currentPage); // 🔥 Recharger la page actuelle
                setDeleteConfirm(null);
            } else {
                setError(data.message);
            }
        } catch (err) {
            setError('Erreur lors de la suppression');
        }
    };

    // Corriger la fonction getStatusCounts
    const getStatusCounts = () => {
        const total = transactions.length;
        const encaissement = transactions.filter(t => t.type === 'encaissement').length;
        const decaissement = transactions.filter(t => t.type === 'décaissement').length;
        return { total, encaissement, decaissement };
    };

    const statusCounts = getStatusCounts();

    const filteredTransactions = transactions.filter(transaction => {
        const matchesSearch = searchTerm === '' ||
            transaction.description?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            transaction.category_name?.toLowerCase().includes(searchTerm.toLowerCase());
        return matchesSearch;
    });

    // 🔥 AJOUT: Composant de pagination
    const Pagination = () => {
        if (pagination.totalPages <= 1) return null;

        return (
            <div className="flex justify-center items-center space-x-2 mt-6">
                {/* Bouton Précédent */}
                <button
                    onClick={() => handlePageChange(pagination.currentPage - 1)}
                    disabled={pagination.currentPage === 1}
                    className={`px-3 py-2 rounded-lg border ${
                        pagination.currentPage === 1
                            ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                            : 'bg-white text-gray-700 hover:bg-gray-50 border-gray-300'
                    }`}
                >
                    ← Précédent
                </button>

                {/* Pages */}
                {Array.from({ length: pagination.totalPages }, (_, i) => i + 1).map(page => (
                    <button
                        key={page}
                        onClick={() => handlePageChange(page)}
                        className={`px-3 py-2 rounded-lg border ${
                            page === pagination.currentPage
                                ? 'bg-blue-500 text-white border-blue-500'
                                : 'bg-white text-gray-700 hover:bg-gray-50 border-gray-300'
                        }`}
                    >
                        {page}
                    </button>
                ))}

                {/* Bouton Suivant */}
                <button
                    onClick={() => handlePageChange(pagination.currentPage + 1)}
                    disabled={pagination.currentPage === pagination.totalPages}
                    className={`px-3 py-2 rounded-lg border ${
                        pagination.currentPage === pagination.totalPages
                            ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                            : 'bg-white text-gray-700 hover:bg-gray-50 border-gray-300'
                    }`}
                >
                    Suivant →
                </button>
            </div>
        );
    };

    return (
        <Sidebar>
            <div className={`min-h-screen bg-gradient-to-br from-green-50 via-emerald-50 to-blue-50 p-4 md:p-6 ${showAdd || editingTransaction || showCategory || showStats ? 'overflow-hidden' : ''}`}>
                <div className="max-w-7xl mx-auto relative">
                    {/* Main content with blur effect when modal is open */}
                    <div className={`transition-all duration-300 ${showAdd || editingTransaction || showCategory || showStats ? 'blur-sm' : ''}`}>

                        {/* Header Section */}
                        <div className="bg-white/90 backdrop-blur-lg rounded-3xl shadow-2xl p-8 mb-8 border border-white/40">
                            <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-8">
                                <div className="flex-1">
                                    <div className="flex items-center mb-4">
                                        <div className="p-3 bg-gradient-to-br from-green-500 to-emerald-600 rounded-2xl shadow-lg mr-4">
                                            <TransactionIcon className="text-white text-xl"/>
                                        </div>
                                        <div>
                                            <h1 className="text-4xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent">
                                                {t('transactions_management')}
                                            </h1>
                                            <p className="text-gray-500 text-sm mt-1">{t('manage_vehicle_transactions')}</p>
                                        </div>
                                    </div>

                                    {/* Vehicle Selection */}
                                    <div className="mb-4">
                                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                                            {t('select_vehicle_label')}
                                        </label>
                                        <select
                                            value={selectedVoiture?.id || ''}
                                            onChange={(e) => {
                                                const voiture = voitures.find(v => v.id === parseInt(e.target.value));
                                                setSelectedVoiture(voiture);
                                            }}
                                            className="px-4 py-2 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-300 focus:border-green-400"
                                        >
                                            <option value="">{t('choose_vehicle')}</option>
                                            {voitures.map(voiture => (
                                                <option key={voiture.id} value={voiture.id}>
                                                    {voiture.marque} {voiture.modele} - {voiture.matricule}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* Status Cards CORRIGÉES */}
                                    <div className="flex flex-wrap gap-6">
                                        <div className="bg-gradient-to-r from-blue-50 to-indigo-50 px-4 py-3 rounded-2xl border border-blue-100 shadow-sm">
                                            <div className="flex items-center space-x-3">
                                                <div className="w-3 h-3 bg-blue-500 rounded-full shadow-sm"></div>
                                                <span className="font-semibold text-gray-700">{t('total_label')}: {statusCounts.total}</span>
                                            </div>
                                        </div>
                                        <div className="bg-gradient-to-r from-green-50 to-emerald-50 px-4 py-3 rounded-2xl border border-green-100 shadow-sm">
                                            <div className="flex items-center space-x-3">
                                                <div className="w-3 h-3 bg-green-500 rounded-full shadow-sm"></div>
                                                <span className="font-semibold text-gray-700">{t('encaissement_label')}: {statusCounts.encaissement}</span>
                                            </div>
                                        </div>
                                        <div className="bg-gradient-to-r from-red-50 to-rose-50 px-4 py-3 rounded-2xl border border-red-100 shadow-sm">
                                            <div className="flex items-center space-x-3">
                                                <div className="w-3 h-3 bg-red-500 rounded-full shadow-sm"></div>
                                                <span className="font-semibold text-gray-700">{t('decaissement_label')}: {statusCounts.decaissement}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Action Buttons */}
                                <div className="flex flex-col sm:flex-row lg:flex-col xl:flex-row gap-4">
                                    <button
                                        onClick={() => setShowStats(true)}
                                        disabled={!selectedVoiture}
                                        className="flex items-center space-x-3 bg-gradient-to-r from-purple-500 to-indigo-600 text-white px-6 py-3.5 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 active:scale-95 group border border-purple-400/30 disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        <div className="p-1 bg-white/20 rounded-lg">
                                            <StatsIcon className="w-4 h-4"/>
                                        </div>
                                        <span className="font-semibold text-sm">{t('statistics_btn')}</span>
                                    </button>

                                    <button
                                        onClick={() => setShowCategory(true)}
                                        className="flex items-center space-x-3 bg-gradient-to-r from-amber-500 to-orange-600 text-white px-6 py-3.5 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 active:scale-95 group border border-amber-400/30"
                                    >
                                        <div className="p-1 bg-white/20 rounded-lg">
                                            <CategoryIcon className="w-4 h-4"/>
                                        </div>
                                        <span className="font-semibold text-sm">{t('categories_btn')}</span>
                                    </button>

                                    <button
                                        onClick={() => {
                                            setEditingTransaction(null);
                                            setShowAdd(true);
                                        }}
                                        disabled={!selectedVoiture}
                                        className="flex items-center space-x-3 bg-gradient-to-r from-blue-500 to-indigo-600 text-white px-6 py-3.5 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 active:scale-95 group border border-blue-400/30 disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        <div className="p-1 bg-white/20 rounded-lg group-hover:rotate-90 transition-transform duration-300">
                                            <AddIcon className="w-4 h-4"/>
                                        </div>
                                        <span className="font-semibold text-sm">{t('new_transaction')}</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Search and Filter Section */}
                        {selectedVoiture && (
                            <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl p-6 mb-6 border border-white/20">
                                <div className="flex flex-col lg:flex-row gap-4">
                                    {/* Search bar */}
                                    <div className="relative flex-grow">
                                        <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                                            <svg className="h-5 w-5 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
                                            </svg>
                                        </div>
                                        <input
                                            type="text"
                                            placeholder={t('search_transactions')}
                                            className="block w-full pl-12 pr-12 py-3 border-2 border-green-100 rounded-xl bg-white/90 shadow-lg focus:outline-none focus:ring-2 focus:ring-green-300 focus:border-green-400 text-gray-700 placeholder-green-300 transition-all duration-300 hover:shadow-md"
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                        {searchTerm && (
                                            <button
                                                onClick={() => setSearchTerm('')}
                                                className="absolute inset-y-0 right-0 pr-4 flex items-center text-green-400 hover:text-green-600 transition-colors"
                                            >
                                                <CloseIcon/>
                                            </button>
                                        )}
                                    </div>

                                    {/* Filter controls CORRIGÉES */}
                                    <div className="flex flex-wrap gap-3">
                                        <div className="flex items-center space-x-2">
                                            <FilterIcon className="w-4 h-4 text-gray-500"/>
                                            <select
                                                value={filters.type}
                                                onChange={(e) => setFilters({ ...filters, type: e.target.value })}
                                                className="px-4 py-2 bg-white border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-300 focus:border-green-400 transition-all"
                                            >
                                                <option value="">{t('all_types')}</option>
                                                <option value="encaissement">{t('encaissement_label')}</option>
                                                <option value="décaissement">{t('decaissement_label')}</option>
                                            </select>
                                        </div>

                                        <select
                                            value={filters.category_id}
                                            onChange={(e) => setFilters({ ...filters, category_id: e.target.value })}
                                            className="px-4 py-2 bg-white border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-300 focus:border-green-400 transition-all"
                                        >
                                            <option value="">{t('all_categories')}</option>
                                            {categories.map(cat => (
                                                <option key={cat.id} value={cat.id}>{cat.name}</option>
                                            ))}
                                        </select>

                                        <input
                                            type="date"
                                            value={filters.startDate}
                                            onChange={(e) => setFilters({ ...filters, startDate: e.target.value })}
                                            className="px-4 py-2 bg-white border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-300 focus:border-green-400 transition-all"
                                            placeholder="Date de début"
                                        />

                                        <input
                                            type="date"
                                            value={filters.endDate}
                                            onChange={(e) => setFilters({ ...filters, endDate: e.target.value })}
                                            className="px-4 py-2 bg-white border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-300 focus:border-green-400 transition-all"
                                            placeholder="Date de fin"
                                        />

                                        <button
                                            onClick={() => {
                                                setFilters({ type: '', category_id: '', startDate: '', endDate: '' });
                                                fetchTransactions(1);
                                            }}
                                            className="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors text-sm"
                                        >
                                            {t('reset')}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Results Section */}
                        <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl overflow-hidden border border-white/20">
                            <div className="p-6">
                                <div className="flex justify-between items-center mb-6">
                                    <h2 className="text-xl font-semibold text-gray-800">
                                        {selectedVoiture ? `${t('transactions_title')} - ${selectedVoiture.marque} ${selectedVoiture.modele}` : t('select_vehicle_label')}
                                    </h2>
                                    {selectedVoiture && (
                                        <div className="text-sm text-gray-500 bg-green-50 px-3 py-1 rounded-full">
                                            {pagination.totalItems} {t('total_transactions')} • {t('page_label')} {pagination.currentPage}/{pagination.totalPages}
                                        </div>
                                    )}
                                </div>

                                {error && (
                                    <div className="mb-6 bg-red-50 border border-red-200 rounded-lg p-4">
                                        <div className="flex items-center">
                                            <svg className="w-5 h-5 text-red-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                                            </svg>
                                            <span className="text-red-700 font-medium">{t('error')}: {error}</span>
                                        </div>
                                    </div>
                                )}

                                {!selectedVoiture ? (
                                    <div className="text-center py-12">
                                        <div className="text-gray-400 text-6xl mb-4">🚗</div>
                                        <h3 className="text-xl font-medium text-gray-700 mb-2">{t('no_vehicle_selected_msg')}</h3>
                                        <p className="text-gray-500">{t('select_vehicle_to_view')}</p>
                                    </div>
                                ) : loading ? (
                                    <LoadingSpinner/>
                                ) : transactions.length === 0 ? (
                                    <div className="text-center py-12">
                                        <div className="text-green-400 text-6xl mb-4">💸</div>
                                        <h3 className="text-xl font-medium text-gray-700 mb-2">{t('no_transactions_msg')}</h3>
                                        <p className="text-gray-500 mb-6">{t('add_first_transaction_desc')}</p>
                                        <button
                                            onClick={() => setShowAdd(true)}
                                            className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-xl shadow-lg hover:shadow-xl transition-all transform hover:scale-105"
                                        >
                                            <AddIcon className="mr-2"/>
                                            {t('add_transaction_btn')}
                                        </button>
                                    </div>
                                ) : filteredTransactions.length === 0 ? (
                                    <div className="text-center py-12">
                                        <svg className="mx-auto h-16 w-16 text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
                                        </svg>
                                        <h3 className="text-xl font-medium text-gray-700 mb-2">{t('no_search_results')}</h3>
                                        <p className="text-gray-500 mb-4">{t('no_matching_transactions')}</p>
                                        <button
                                            onClick={() => {
                                                setSearchTerm('');
                                                setFilters({ type: '', category_id: '', startDate: '', endDate: '' });
                                                fetchTransactions(1);
                                            }}
                                            className="text-green-600 hover:text-green-700 font-medium transition-colors"
                                        >
                                            {t('reset_transaction_filters')}
                                        </button>
                                    </div>
                                ) : (
                                    <>
                                        <div className="overflow-x-auto">
                                            <table className="w-full">
                                                <thead className="bg-gray-50">
                                                <tr>
                                                    <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">{t('date_col')}</th>
                                                    <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">{t('type_col')}</th>
                                                    <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">{t('category_col')}</th>
                                                    <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">{t('description')}</th>
                                                    <th className="px-6 py-4 text-left text-sm font-semibold text-gray-700">{t('amount_col')}</th>
                                                    <th className="px-6 py-4 text-center text-sm font-semibold text-gray-700">{t('actions_col')}</th>
                                                </tr>
                                                </thead>
                                                <tbody className="divide-y divide-gray-200">
                                                {filteredTransactions.map((transaction) => (
                                                    <tr key={transaction.id} className="hover:bg-green-50/30 transition-colors duration-200">
                                                        <td className="px-6 py-4">
                                                                <span className="text-sm text-gray-600">
                                                                    {new Date(transaction.date).toLocaleDateString('fr-FR')}
                                                                </span>
                                                        </td>
                                                        <td className="px-6 py-4">
                                                                <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${
                                                                    transaction.type === 'encaissement'
                                                                        ? 'bg-green-100 text-green-800'
                                                                        : 'bg-red-100 text-red-800'
                                                                }`}>
                                                                    {transaction.type === 'encaissement' ? `💰 ${t('encaissement_type')}` : `💸 ${t('decaissement_type')}`}
                                                                </span>
                                                        </td>
                                                        <td className="px-6 py-4">
                                                            <span className="text-gray-700">{transaction.category_name || t('uncategorized')}</span>
                                                        </td>
                                                        <td className="px-6 py-4">
                                                            <span className="text-gray-600">{transaction.description || '-'}</span>
                                                        </td>
                                                        <td className="px-6 py-4">
                                                                <span className={`text-lg font-semibold ${
                                                                    transaction.type === 'encaissement' ? 'text-green-600' : 'text-red-600'
                                                                }`}>
                                                                    {transaction.type === 'encaissement' ? '+' : '-'}{transaction.amount} DA
                                                                </span>
                                                        </td>
                                                        <td className="px-6 py-4">
                                                            <div className="flex justify-center space-x-3">
                                                                <button
                                                                    onClick={() => {
                                                                        setEditingTransaction(transaction);
                                                                        setShowAdd(true);
                                                                    }}
                                                                    className="flex items-center space-x-2 bg-blue-50 text-blue-600 px-3 py-2 rounded-lg hover:bg-blue-100 transition-colors duration-200 text-sm font-medium"
                                                                >
                                                                    <span>✏️</span>
                                                                    <span>{t('edit_transaction_btn')}</span>
                                                                </button>
                                                                <button
                                                                    onClick={() => setDeleteConfirm(transaction.id)}
                                                                    className="flex items-center space-x-2 bg-red-50 text-red-600 px-3 py-2 rounded-lg hover:bg-red-100 transition-colors duration-200 text-sm font-medium"
                                                                >
                                                                    <span>🗑️</span>
                                                                    <span>{t('delete_transaction_btn')}</span>
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                                </tbody>
                                            </table>
                                        </div>

                                        {/* 🔥 AJOUT: Pagination en bas du tableau */}
                                        <Pagination />
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                    {/* Add/Edit Transaction Modal */}
                    {(showAdd || editingTransaction) && (
                        <div className="fixed inset-0 flex items-center justify-center z-50 p-4">
                            <div
                                className="absolute inset-0 bg-black/50 backdrop-blur-sm"
                                onClick={() => {
                                    setShowAdd(false);
                                    setEditingTransaction(null);
                                }}
                            ></div>

                            <div className="relative z-10 w-full max-w-2xl max-h-[90vh] overflow-y-auto">
                                <TransactionForm
                                    transaction={editingTransaction}
                                    categories={categories}
                                    onSubmit={editingTransaction ? handleUpdateTransaction : handleCreateTransaction}
                                    onCancel={() => {
                                        setShowAdd(false);
                                        setEditingTransaction(null);
                                    }}
                                />
                            </div>
                        </div>
                    )}

                    {/* Statistics Modal */}
                    {showStats && selectedVoiture && (
                        <div className="fixed inset-0 flex items-center justify-center z-50 p-4">
                            <div
                                className="absolute inset-0 bg-black/50 backdrop-blur-sm"
                                onClick={() => setShowStats(false)}
                            ></div>

                            <div className="relative z-10 w-full max-w-4xl max-h-[90vh] overflow-y-auto">
                                <StatisticsModal
                                    voitureId={selectedVoiture.id}
                                    onClose={() => setShowStats(false)}
                                />
                            </div>
                        </div>
                    )}

                    {/* Categories Modal */}
                    {showCategory && (
                        <div className="fixed inset-0 flex items-center justify-center z-50 p-4">
                            <div
                                className="absolute inset-0 bg-black/50 backdrop-blur-sm"
                                onClick={() => setShowCategory(false)}
                            ></div>

                            <div className="relative z-10 w-full max-w-4xl max-h-[90vh] overflow-y-auto bg-white rounded-2xl shadow-2xl p-6">
                                <div className="flex justify-between items-center mb-4">
                                    <h2 className="text-2xl font-bold text-gray-800">{t('manage_categories_title_modal')}</h2>
                                    <button
                                        onClick={() => setShowCategory(false)}
                                        className="text-gray-500 hover:text-gray-700"
                                    >
                                        <CloseIcon />
                                    </button>
                                </div>
                                <CategoryManager />
                            </div>
                        </div>
                    )}

                    {/* Delete confirmation modal */}
                    {deleteConfirm && (
                        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4 z-50">
                            <div className="bg-white rounded-2xl shadow-2xl overflow-hidden w-full max-w-md border border-gray-200 animate-fadeIn">
                                <div className="p-6">
                                    <div className="flex items-start">
                                        <div className="flex-shrink-0 h-12 w-12 rounded-full bg-red-100 flex items-center justify-center">
                                            <svg className="h-6 w-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
                                            </svg>
                                        </div>
                                        <div className="ml-4">
                                            <h3 className="text-lg font-semibold text-gray-900 mb-2">{t('delete_transaction_title')}</h3>
                                            <p className="text-sm text-gray-600">
                                                {t('delete_transaction_confirm')}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="bg-gray-50 px-6 py-4 flex justify-end space-x-3">
                                    <button
                                        onClick={() => setDeleteConfirm(null)}
                                        className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium"
                                    >
                                        {t('cancel')}
                                    </button>
                                    <button
                                        onClick={() => handleDeleteTransaction(deleteConfirm)}
                                        className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors flex items-center space-x-2 font-medium"
                                    >
                                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                        </svg>
                                        <span>{t('delete')}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </Sidebar>
    );
};

// Transaction Form Component
const TransactionForm = ({ transaction, categories, onSubmit, onCancel }) => {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        category_id: '',
        amount: '',
        description: '',
        type: 'décaissement',
        date: new Date().toISOString().split('T')[0]
    });

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (transaction) {
            setFormData({
                category_id: transaction.category_id || '',
                amount: transaction.amount,
                description: transaction.description || '',
                type: transaction.type,
                date: transaction.date.split('T')[0]
            });
        }
    }, [transaction]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            await onSubmit(formData);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="bg-white rounded-3xl shadow-2xl w-full max-w-2xl">
            <div className="bg-gradient-to-r from-blue-500 to-indigo-600 p-6 rounded-t-3xl">
                <div className="flex items-center justify-between">
                    <h2 className="text-2xl font-bold text-white">
                        {transaction ? t('transaction_form_title_edit') : t('transaction_form_title_new')}
                    </h2>
                    <button
                        onClick={onCancel}
                        className="text-white/80 hover:text-white text-2xl"
                    >
                        ×
                    </button>
                </div>
            </div>

            <form onSubmit={handleSubmit} className="p-6 space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                            {t('transaction_type_label')}
                        </label>
                        <select
                            value={formData.type}
                            onChange={(e) => setFormData({ ...formData, type: e.target.value })}
                            className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-400 focus:border-transparent"
                            required
                        >
                            <option value="décaissement">💸 {t('decaissement_type')}</option>
                            <option value="encaissement">💰 {t('encaissement_type')}</option>
                        </select>
                    </div>

                    {/* Amount */}
                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                            {t('transaction_amount_label')}
                        </label>
                        <input
                            type="number"
                            step="0.01"
                            value={formData.amount}
                            onChange={(e) => setFormData({ ...formData, amount: e.target.value })}
                            className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-400 focus:border-transparent"
                            placeholder="0.00"
                            required
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                            {t('transaction_category_label')}
                        </label>
                        <select
                            value={formData.category_id}
                            onChange={(e) => setFormData({ ...formData, category_id: e.target.value })}
                            className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-400 focus:border-transparent"
                        >
                            <option value="">{t('all_categories')}</option>
                            {categories.map((cat) => (
                                <option key={cat.id} value={cat.id}>
                                    {cat.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">
                            {t('transaction_date_label')}
                        </label>
                        <input
                            type="date"
                            value={formData.date}
                            onChange={(e) => setFormData({ ...formData, date: e.target.value })}
                            className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-400 focus:border-transparent"
                            required
                        />
                    </div>
                </div>

                <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                        {t('transaction_description_label')}
                    </label>
                    <textarea
                        value={formData.description}
                        onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                        rows="3"
                        className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-400 focus:border-transparent"
                        placeholder={t('description')}
                    />
                </div>

                {/* Action Buttons */}
                <div className="flex flex-wrap gap-4 pt-6 border-t border-gray-200">
                    <button
                        type="submit"
                        disabled={loading}
                        className="flex items-center space-x-3 bg-gradient-to-r from-blue-500 to-indigo-600 text-white px-8 py-3 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {loading ? (
                            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                        ) : (
                            <span>💾</span>
                        )}
                        <span className="font-semibold">
                            {loading ? t('updating') : transaction ? t('transaction_submit_update') : t('transaction_submit_create')}
                        </span>
                    </button>

                    <button
                        type="button"
                        onClick={onCancel}
                        className="flex items-center space-x-3 bg-gradient-to-r from-gray-400 to-gray-500 text-white px-8 py-3 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 active:scale-95"
                    >
                        <span>❌</span>
                        <span className="font-semibold">{t('cancel')}</span>
                    </button>
                </div>
            </form>
        </div>
    );
};

// Statistics Modal Component
// Statistics Modal Component
const StatisticsModal = ({ voitureId, onClose }) => {
    const { t } = useTranslation();
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(false);
    const [dateRange, setDateRange] = useState({
        startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split('T')[0],
        endDate: new Date().toISOString().split('T')[0]
    });

    const fetchStats = async () => {
        try {
            setLoading(true);
            const queryParams = new URLSearchParams(dateRange).toString();
            const response = await fetch(
                `https://krili-loto.com/api/transactionscar/car/${voitureId}/stats?${queryParams}`
            );
            const data = await response.json();

            if (data.success) {
                setStats(data.data);
            }
        } catch (err) {
            console.error('Error fetching stats:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchStats();
    }, [dateRange]);

    // Fonction pour calculer les totaux depuis les données réelles
    const calculateTotals = () => {
        if (!stats) return { totalEncaissement: 0, totalDecaissement: 0, netAmount: 0 };

        let totalEncaissement = 0;
        let totalDecaissement = 0;

        // Calculer depuis typeStats
        stats.typeStats.forEach(stat => {
            if (stat.type === 'encaissement') {
                totalEncaissement = parseFloat(stat.total_amount) || 0;
            } else if (stat.type === 'décaissement') {
                totalDecaissement = parseFloat(stat.total_amount) || 0;
            }
        });

        const netAmount = totalEncaissement - totalDecaissement;

        return { totalEncaissement, totalDecaissement, netAmount };
    };

    const totals = calculateTotals();

    return (
        <div className="bg-white rounded-3xl shadow-2xl w-full max-w-4xl">
            <div className="bg-gradient-to-r from-purple-500 to-indigo-600 p-6 rounded-t-3xl">
                <div className="flex items-center justify-between">
                    <h2 className="text-2xl font-bold text-white">{t('statistics_btn')}</h2>
                    <button
                        onClick={onClose}
                        className="text-white/80 hover:text-white text-2xl"
                    >
                        ×
                    </button>
                </div>
            </div>

            <div className="p-6">
                {/* Date Range Selector */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
                    <input
                        type="date"
                        value={dateRange.startDate}
                        onChange={(e) => setDateRange({ ...dateRange, startDate: e.target.value })}
                        className="px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-purple-400"
                    />
                    <input
                        type="date"
                        value={dateRange.endDate}
                        onChange={(e) => setDateRange({ ...dateRange, endDate: e.target.value })}
                        className="px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-purple-400"
                    />
                    <button
                        onClick={fetchStats}
                        disabled={loading}
                        className="px-4 py-3 bg-purple-500 text-white rounded-xl hover:bg-purple-600 disabled:opacity-50"
                    >
                        {loading ? t('loading') : t('refresh')}
                    </button>
                </div>

                {stats ? (
                    <>
                        {/* Summary Cards CORRIGÉES - Utiliser les totaux calculés */}
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
                            <div className="bg-gradient-to-r from-green-50 to-emerald-50 p-6 rounded-2xl border border-green-200">
                                <div className="flex items-center justify-between">
                                    <div>
                                        <p className="text-green-600 text-sm font-semibold">{t('encaissement_label')}</p>
                                        <p className="text-2xl font-bold text-green-700">
                                            {totals.totalEncaissement.toLocaleString('fr-FR')} DA
                                        </p>
                                    </div>
                                    <div className="text-green-500 text-2xl">💰</div>
                                </div>
                            </div>

                            <div className="bg-gradient-to-r from-red-50 to-rose-50 p-6 rounded-2xl border border-red-200">
                                <div className="flex items-center justify-between">
                                    <div>
                                        <p className="text-red-600 text-sm font-semibold">{t('decaissement_label')}</p>
                                        <p className="text-2xl font-bold text-red-700">
                                            {totals.totalDecaissement.toLocaleString('fr-FR')} DA
                                        </p>
                                    </div>
                                    <div className="text-red-500 text-2xl">💸</div>
                                </div>
                            </div>

                            <div className={`p-6 rounded-2xl border ${
                                totals.netAmount >= 0
                                    ? 'bg-gradient-to-r from-blue-50 to-cyan-50 border-blue-200'
                                    : 'bg-gradient-to-r from-amber-50 to-orange-50 border-amber-200'
                            }`}>
                                <div className="flex items-center justify-between">
                                    <div>
                                        <p className="text-gray-600 text-sm font-semibold">{t('net_balance')}</p>
                                        <p className={`text-2xl font-bold ${
                                            totals.netAmount >= 0 ? 'text-blue-700' : 'text-amber-700'
                                        }`}>
                                            {totals.netAmount >= 0 ? '+' : ''}{totals.netAmount.toLocaleString('fr-FR')} DA
                                        </p>
                                    </div>
                                    <div className={`text-2xl ${
                                        totals.netAmount >= 0 ? 'text-blue-500' : 'text-amber-500'
                                    }`}>
                                        {totals.netAmount >= 0 ? '📈' : '📉'}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Category Breakdown */}
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                            <div className="bg-white rounded-2xl border border-gray-200 p-6">
                                <h3 className="text-lg font-semibold text-gray-800 mb-4">{t('type_col')}</h3>
                                <div className="space-y-4">
                                    {stats.typeStats.map((stat) => (
                                        <div key={stat.type} className="flex items-center justify-between">
                                            <span className="flex items-center space-x-2">
                                                <span className={`w-3 h-3 rounded-full ${
                                                    stat.type === 'encaissement' ? 'bg-green-500' : 'bg-red-500'
                                                }`}></span>
                                                <span className="font-medium text-gray-700">
                                                    {stat.type === 'encaissement' ? t('encaissement_label') : t('decaissement_label')}
                                                </span>
                                            </span>
                                            <div className="text-right">
                                                <p className="font-semibold text-gray-800">
                                                    {parseFloat(stat.total_amount).toLocaleString('fr-FR')} DA
                                                </p>
                                                <p className="text-sm text-gray-500">{stat.transaction_count} transactions</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="bg-white rounded-2xl border border-gray-200 p-6">
                                <h3 className="text-lg font-semibold text-gray-800 mb-4">{t('category_col')}</h3>
                                <div className="space-y-3 max-h-64 overflow-y-auto">
                                    {stats.categoryStats.map((stat, index) => (
                                        <div key={index} className="flex items-center justify-between">
                                            <span className="text-sm text-gray-700">
                                                {stat.category_name || t('uncategorized')}
                                            </span>
                                            <div className="text-right">
                                                <p className={`text-sm font-medium ${
                                                    stat.type === 'encaissement' ? 'text-green-600' : 'text-red-600'
                                                }`}>
                                                    {stat.type === 'encaissement' ? '+' : '-'}{parseFloat(stat.total_amount).toLocaleString('fr-FR')} DA
                                                </p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </>
                ) : (
                    <div className="text-center py-12">
                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-500 mx-auto mb-4"></div>
                        <p className="text-gray-600">{t('loading_stats')}</p>
                    </div>
                )}
            </div>
        </div>
    );
};
export default CarTransactionsPage;